import MyRequest from './request'

import { URL_BASE, TIME_OUT, URL_ADMIN } from './config'

import { localCache, sessionCache } from '@/utils/comm'
import { ACCESS_TOKEN, USER_SYSTEM_ROLE } from '@/global/constants'

const RequestService = new MyRequest({
  baseURL: URL_BASE,
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn: config => {
      // 每一个请求都自动携带token
      const access_token = localCache.getCache(ACCESS_TOKEN)
      const user_system_role = sessionCache.getCache(USER_SYSTEM_ROLE)
      if (config.headers) {
        if (access_token) {
          // 类型缩小
          config.headers['Authorization'] = `Bearer ${access_token}`
        }

        // 类型缩小
        let role = user_system_role
        if (location.pathname == '/invite-service') {
          role = 'SERVICE'
        }
        if (location.pathname == '/invite-brand') {
          role = 'BRAND'
        }
        config.headers[USER_SYSTEM_ROLE] = role
      }
      return config
    }
  }
})

const RequestServiceAdmin = new MyRequest({
  baseURL: URL_ADMIN,
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn: config => {
      // if (config && config.headers) {
      //   // config.headers['Authorization'] = `Basic ${Base64.encode('cc')}`
      // }

      // 每一个请求都自动携带token
      const access_token = localCache.getCache(ACCESS_TOKEN)
      const user_system_role = sessionCache.getCache(USER_SYSTEM_ROLE)
      if (config.headers) {
        if (access_token) {
          // 类型缩小
          config.headers['Authorization'] = `Bearer ${access_token}`
        }
        if (user_system_role) {
          // 类型缩小
          config.headers[USER_SYSTEM_ROLE] = user_system_role
        }
      }
      return config
    }
  }
})
export { RequestServiceAdmin }
export default RequestService
